import { render, staticRenderFns } from "./AccountSettingsHeader.vue?vue&type=template&id=215b6f1d&scoped=true"
import script from "./AccountSettingsHeader.vue?vue&type=script&lang=js"
export * from "./AccountSettingsHeader.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsHeader.vue?vue&type=style&index=0&id=215b6f1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b6f1d",
  null
  
)

export default component.exports